import { FORM_COLOR } from '@app/constant/ColorDefault'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const TypographyCustomizer = styled(Typography)({
  color: FORM_COLOR.REQUIRED_ERROR,
  marginLeft: '14px !important',
})

export const DivCustomizer = styled('div')({
  '& .ck .ck-editor__main > .ck-editor__editable': {
    minHeight: '150px',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '& .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar': {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
})
